
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import promotionCodeModule from '@/store/promotion-code'
import whitelabelModule from '@/store/whitelabel'
import { TextFieldRules } from '@/utils/enums'
import { PromotionCode } from '../../types/PromotionCode'
import { format } from 'date-fns'

@Component({
  name: 'PromotionCodeEditor'
})
class PromotionCodeEditor extends Vue {
  @Prop() readonly edit?: boolean
  private rules = TextFieldRules
  private showStartDate = false
  private showEndDate = false

  private form: Partial<PromotionCode> = {
    name: '',
    code: '',
    points: this.whitelabel.settings.invitePoints,
    startDate: undefined,
    endDate: undefined,
    enable: true
  }

  private get promotionCode(): PromotionCode | undefined {
    return promotionCodeModule.promotionCode
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  @Watch('promotioncode')
  private setPromotionCode(): void {
    if (!this.edit) return
    this.form = JSON.parse(JSON.stringify(this.promotionCode))
  }

  private created(): void {
    this.setPromotionCode()
  }

  private get formattedEndDate() {
    if (!this.form.endDate) return ''
    return format(new Date(this.form.endDate!), 'dd.MM.yyyy')
  }

  private get formattedStartDate() {
    if (!this.form.startDate) return ''
    return format(new Date(this.form.startDate!), 'dd.MM.yyyy')
  }

  private async savePromotionCode(): Promise<void> {
    Object.assign(this.form, { whitelabel: this.whitelabel._id })
    if (!this.edit) {
      promotionCodeModule.create(this.form)
    } else {
      promotionCodeModule.update(this.form)
    }
    document.dispatchEvent(new Event('close-promotion-code'))
  }
}

export default PromotionCodeEditor
